import { render } from "./App.vue?vue&type=template&id=bdb76f04"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.esm.css?vue&type=style&index=0&lang=css&external"
import "./App.vue?vue&type=style&index=1&id=bdb76f04&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__